export default {
  verifyNumI18nEnum: ['ResGTrack'],
  /**
   * @Date: 2022-10-31 11:01:22
   * @method: 校验单号
   * @param {string} str 单号
   * @return {string} 返回错误信息词条内容或空
   * @Author: wzt
   */
  verifyNum(str: string): string {
    const mix = 5
    const max = 50
    if(str === ''){
      return 'ResGTrack.global.__inputMsg_null'
    }
    if(str.length < mix || str.length > max){
      return 'ResGTrack.global.__inputMsg_character'
    }
    if (!/^[A-Z0-9_.\-/]{5,50}$/g.test(str)) {
      return 'ResGTrack.global.__inputMsg_illegal'
    }
    return ''
  },
  getDownloadUrl() {
		const userAgent= navigator.userAgent.toLowerCase()
    const u = navigator.userAgent
    const isWeixin = userAgent.indexOf("micromessenger") !== -1
    const isIos = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1
    let href = ''
    // console.log(userAgent, u, isWeixin, isIos)
    // ios
    if (isIos) {
      href = 'https://apps.apple.com/cn/app/id1004956012'
    } else { // 其他所有
      const country = window.YQ.country
      const lang = window.YQ.configs.lang
      // 国家不是中国，跳到谷歌play应用商店
      if ((country && country !== 'CN' ) || (!country && lang !== 'zh-cn')) {
          href = 'https://play.google.com/store/apps/details?id=yqtrack.app'
      }else {// 国内
          // 微信
          if (isWeixin) {
              href = 'https://a.app.qq.com/o/simple.jsp?pkgname=yqtrack.app'
          } else {
              // 国内应用商店
              href = '//download.17track.net/17track.apk'
          }
          
      }
    }
		return href
	},
  debounce(func: any, delay: number) {    
    let timeout: any = null  
    return (...args: any) => {        
      if(timeout !== null) {
        clearTimeout(timeout)
      }
      const context = this
        timeout = setTimeout(function(){
        func.apply(context, args)
      }, delay)
    }
  },
  queryURLParams(URL: string, key?: string) {
    // const url = location.search; // 项目中可直接通过search方法获取url中"?"符后的字串
    if (!URL) return {}
    const url = URL.split(key || '?')[1]
    const obj: any = {} // 声明参数对象
    const arr = url.split("&") // 以&符号分割为数组
    for (let i = 0; i < arr.length; i++) {
      const arrNew: any = arr[i].split("=") // 以"="分割为数组
      obj[arrNew[0]] = arrNew[1]
    }
    return obj
  },
  // 获取链接参数
  getUrlParams(key: string) {
    const search: any  = this.queryURLParams(window.location.search)
    const hash: any = this.queryURLParams(window.location.hash, '#')
    // search = new URLSearchParams(search)
    // hash = new URLSearchParams(hash)
    let value = search[key] || hash[key] || ''
    if (key === 'nums' && value.indexOf(',') !== -1) {
      value = value.split(',')[0]
    }
    return value
  }
}